import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router'
import i18next from 'i18next'

import buttonStyles from './styles/button.scss'

import illustration from './../assets/images/wopi-error.png'

export default class NotFound extends React.Component {
  render() {
    return (
      <section>
        <Row>
          <Col smOffset={2} sm={4}>
            <h1>{i18next.t('oops')}</h1>

            <p>{i18next.t('not_found_description')}</p>

            <br />

            <p>
              <Link to="/" className={buttonStyles.button}>
                {i18next.t('back_to_home')}
              </Link>
            </p>
          </Col>

          <Col sm={4} style={{ textAlign: 'right' }}>
            <img src={illustration} alt="WOPI" style={{ width: '100%', maxWidth: '300px' }} />
          </Col>
        </Row>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js